module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarX-7@3x.c33eeb66.png";